import React from 'react';
/* This files links all pages components "entry points" of a project */
// MODULES_APPEND_INDEX_ON_IMPORTS

export const modules = [
  {
    id: 'HomeParticulares',
    loader: React.lazy(() => import('../../src/pages/HomeParticulares')),
  },
  {
    id: 'DistrisFusion',
    loader: React.lazy(() => import('../../src/pages/DistrisFusion')),
  },
  {
    id: 'ConfigFusion',
    loader: React.lazy(() => import('../../src/pages/DistrisFusion')),
  },
  {
    id: 'FichaFusion',
    loader: React.lazy(() => import('../../src/pages/FichaFusion')),
  },
  {
    id: 'LandingFusion',
    loader: React.lazy(() => import('../../src/pages/FichaFusion')),
  },
  {
    id: 'Confirmation',
    loader: React.lazy(() => import('../../src/pages/Confirmation')),
  },
  // MODULES_APPEND_INDEX_ON_MODULES
]
